import { ADD_DEMAND_COMMENT } from "../../actions/actionTypes";

const initialState = {
    comments: [],
    next:null,
    isLoading:false  
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_DEMAND_COMMENT.REQUEST:
            return {...state,isLoading:true}
        case ADD_DEMAND_COMMENT.FAILURE:
            return {...state,isLoading:false}
        case ADD_DEMAND_COMMENT.SUCCESS:  
        return {
            ...state,
            comments: action.obj.isLoadMore ? [...state.comments,...action.obj.data] : action.obj.data,
            next: action.obj.next,
            isLoading:false
          };
        default:
            return state
    }
}

export default reducer;